import { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './Dashboard.css';

function Dashboard({ user }) {
    const [sessions, setSessions] = useState([]);
    const [stats, setStats] = useState({
        totalHours: 47.5,
        activeSessions: 1,
        upcomingBookings: 3
    });

    useEffect(() => {
        setSessions([
            {
                id: '1',
                name: 'LLM Fine-tuning',
                status: 'Running',
                gpuCount: 1,
                memoryUsed: '24GB / 40GB',
                createdAt: '1h ago'
            },
            {
                id: '2',
                name: 'Computer Vision Model',
                status: 'Stopped',
                gpuCount: 1,
                memoryUsed: '0GB / 40GB',
                createdAt: '1d ago'
            }
        ]);
    }, []);

    const navigate = useNavigate();

    return (
        <div className="dashboard-page">
            <div className="dashboard-container">
                <div className="dashboard-header">
                    <div>
                        <h1>Welcome back, {user?.name}!</h1>
                        <p>Manage your GPU sessions and track your usage</p>
                    </div>
                    <Link to="/notebook" className="btn-new-notebook">
                        + New Notebook
                    </Link>
                </div>

                {/* Stats Cards */}
                <div className="stats-cards">
                    <div className="stat-card stat-purple">
                        <div className="stat-icon">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" />
                                <path d="M12 6v6l4 2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                            </svg>
                        </div>
                        <div className="stat-info">
                            <div className="stat-value">{stats.totalHours}h</div>
                            <div className="stat-label">Total GPU Time</div>
                        </div>
                    </div>

                    <div className="stat-card stat-green">
                        <div className="stat-icon">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect x="4" y="4" width="16" height="16" rx="2" stroke="currentColor" strokeWidth="2" />
                                <path d="M9 12h6m-3-3v6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                            </svg>
                        </div>
                        <div className="stat-info">
                            <div className="stat-value">{stats.activeSessions}</div>
                            <div className="stat-label">Active Sessions</div>
                        </div>
                    </div>

                    <div className="stat-card stat-blue">
                        <div className="stat-icon">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M3 13h2l2-7 4 14 4-14 2 7h2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </div>
                        <div className="stat-info">
                            <div className="stat-value">{stats.upcomingBookings}</div>
                            <div className="stat-label">Upcoming Bookings</div>
                        </div>
                    </div>
                </div>

                {/* Sessions */}
                <div className="sessions-section">
                    <div className="sessions-header">
                        <h2>Your Sessions</h2>
                        <Link to="/calendar" className="btn-view-calendar">
                            <img src="/svg/graph.svg" alt="" style={{ width: '16px', opacity: 0.7 }} />
                            View Calendar
                        </Link>
                    </div>

                    <div className="sessions-grid">
                        {sessions.map((session) => (
                            <div key={session.id} className="session-card">
                                <div className="session-card-header">
                                    <div className="session-name">
                                        <img src="/svg/folder.svg" alt="" style={{ width: '18px', opacity: 0.7 }} />
                                        <h3>{session.name}</h3>
                                    </div>
                                    <div className={`session-status ${session.status.toLowerCase()}`}>
                                        <span className="status-dot"></span>
                                        {session.status}
                                    </div>
                                </div>

                                <div className="session-details">
                                    <div className="detail-row">
                                        <img src="/svg/database-cog.svg" alt="" style={{ width: '14px', opacity: 0.6 }} />
                                        <span>{session.gpuCount}x A100 GPU</span>
                                    </div>
                                    <div className="detail-row">
                                        <img src="/svg/graph.svg" alt="" style={{ width: '14px', opacity: 0.6 }} />
                                        <span>{session.memoryUsed}</span>
                                    </div>
                                    <div className="detail-row">
                                        <img src="/svg/graph.svg" alt="" style={{ width: '14px', opacity: 0.6 }} />
                                        <span>{session.createdAt}</span>
                                    </div>
                                </div>

                                <div className="session-actions">
                                    <button
                                        onClick={() => navigate(`/notebook/${session.id}`)}
                                        className="btn-session-action"
                                    >
                                        <img src="/svg/play-circle.svg" alt="" style={{ width: '16px' }} />
                                        {session.status === 'Running' ? 'Resume' : 'Restart'}
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Dashboard;
